module.exports = __webpack_public_path__ + "img/about4.62854a8f.png";